import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { SocialProfileType } from '@/types/socialProfileType';

//lib
import { formatAddedSocialProfile } from '@/lib/socialProfile';

// Types
import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';
//Components
import ItemWrapper from '@/components/pages/reports/components/Items/ItemWrapper';

type CompetitorsItemProps = {
    item: SocialProfileType;
    size?: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
};

const CompetitorsItem = ({ item, size = 'sm', className }: CompetitorsItemProps) => {
    const { t } = useTranslation('reports');
    return (
        <ItemWrapper
            spList={[item]}
            mainContent={`${t('create.competitors_from')} ${
                formatAddedSocialProfile(item).main_name
            }`}
            subContent={formatAddedSocialProfile(item).sub_name}
            size={size}
            className={className}
        />
    );
};

export default CompetitorsItem;
